import { render, staticRenderFns } from "./CreateLocationAdditionalCharge.vue?vue&type=template&id=27625562&"
import script from "./CreateLocationAdditionalCharge.vue?vue&type=script&lang=js&"
export * from "./CreateLocationAdditionalCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports